import useRequest from '@/shared/lib/use-request'
import { IUser } from '../model/types'
import { ConfigStore } from '@/shared/model/store'
import { getContentFromHash } from '@/widgets/post-editor/lib/utils'
import { UserStore } from '../model/user-store'

const useSaveUser = () => {
	const { domain } = ConfigStore()
	const { setUserData, setUserNpos, userData, user_npos } = UserStore()

	const fetchUser = useRequest<IUser>('getUser')
	const fetchUserNpos = useRequest<IUser[]>('listNpo')

	const getUser = async (address: `0x${string}`, onSuccessRes?: () => void) => {
		await fetchUser.fetch({
			params: {
				domain,
				user_addr: address
			},
			onSuccess: async res => {
				const userProfile = await getContentFromHash(res.profile_cid)
				const parced = userProfile ? JSON.parse(userProfile) : {}
				setUserData({ ...res, ...parced })
				onSuccessRes && onSuccessRes()
			}
		})
	}

	const getUserNpos = async (address: `0x${string}`) => {
		await fetchUserNpos.fetch({
			params: {
				user_addr: address,
				limit: 100,
				confirmed_only: true
			},
			onSuccess: async res => {
				setUserNpos(res)
			}
		})
	}

	const checkNpo = (address: `0x${string}`) => {
		return user_npos?.find((el: IUser) => el.address === address) || null
	}

	return {
		getUser,
		getUserNpos,
		userAddress: userData?.address,
		checkNpo
	}
}

export default useSaveUser
